module.exports = __webpack_public_path__ + "static/00003.c58db599.jpg";